import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, queryString } from "../api.js";
import { ErrorBox, Pager, fmtRelative, shortHwid, SuccessBox } from "../components/helpers.jsx";

const LIMIT = 50;

export default function Bans() {
    const [data, setData]     = useState({ rows: [], total: 0 });
    const [q, setQ]           = useState("");
    const [active, setActive] = useState("1");
    const [offset, setOffset] = useState(0);
    const [err, setErr]       = useState(null);
    const [msg, setMsg]       = useState(null);
    const [reloadAt, setReload] = useState(0);

    // Manual ban form
    const [banSubject, setBanSubject] = useState("");
    const [banReason, setBanReason] = useState("");

    useEffect(() => {
        let alive = true;
        api.get("/api/admin/bans" + queryString({ q, active, limit: LIMIT, offset }))
            .then((d) => { if (alive) setData(d); })
            .catch((e) => { if (alive) setErr(e.message); });
        return () => { alive = false; };
    }, [q, active, offset, reloadAt]);

    async function liftBan(id) {
        if (!confirm("Lift this ban? Removes the subject's hwid_bans rows too.")) return;
        setErr(null); setMsg(null);
        try {
            const r = await api.post(`/api/admin/bans/${id}/lift`);
            setMsg(`Ban lifted (removed ${r.removedHwidRows} HWID rows).`);
            setReload(Date.now());
        } catch (e) { setErr(e.message); }
    }

    async function manualBan(e) {
        e.preventDefault();
        if (!banSubject || !banReason) return;
        setErr(null); setMsg(null);
        try {
            const r = await api.post("/api/admin/bans", { subject: banSubject, reason: banReason });
            setMsg(`Banned #${r.banId} — cascaded ${r.cascadedHwidRows} HWID rows.`);
            setBanSubject(""); setBanReason("");
            setReload(Date.now());
        } catch (e) { setErr(e.message); }
    }

    return (
        <>
            <div className="page-header">
                <div>
                    <h1>Bans</h1>
                    <div className="sub">Subject bans. Lifting also removes the subject's HWID ban rows.</div>
                </div>
            </div>

            <ErrorBox>{err}</ErrorBox>
            <SuccessBox>{msg}</SuccessBox>

            <div className="card" style={{ marginTop: msg || err ? 12 : 0 }}>
                <h2>Manual ban</h2>
                <form className="row" onSubmit={manualBan} style={{ marginTop: 6 }}>
                    <input placeholder="subject" value={banSubject}
                           onChange={(e) => setBanSubject(e.target.value)} style={{ flex: 1 }} />
                    <input placeholder="reason"  value={banReason}
                           onChange={(e) => setBanReason(e.target.value)} style={{ flex: 2 }} />
                    <button className="primary" type="submit" disabled={!banSubject || !banReason}>Ban</button>
                </form>
            </div>

            <div className="table-wrap">
                <div className="table-toolbar">
                    <input placeholder="Search subject / reason / ip…" value={q}
                           onChange={(e) => { setOffset(0); setQ(e.target.value); }} />
                    <select value={active} onChange={(e) => { setOffset(0); setActive(e.target.value); }}>
                        <option value="">all</option>
                        <option value="1">active</option>
                        <option value="0">lifted</option>
                    </select>
                </div>
                <table className="data">
                    <thead>
                        <tr>
                            <th>When</th>
                            <th>Subject</th>
                            <th>HWID</th>
                            <th>Status</th>
                            <th>Category</th>
                            <th>Reason</th>
                            <th>Source</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.rows.length === 0 && (
                            <tr><td colSpan={8} className="text-dim" style={{ padding: 24, textAlign: "center" }}>
                                No bans
                            </td></tr>
                        )}
                        {data.rows.map((r) => (
                            <tr key={r.id}>
                                <td title={new Date(r.createdAt).toLocaleString()}>
                                    <Link to={`/bans/${r.id}`}>{fmtRelative(r.createdAt)}</Link>
                                </td>
                                <td>
                                    {r.subjectLabel && (
                                        <div style={{ fontWeight: 500 }}>{r.subjectLabel}</div>
                                    )}
                                    <div className="mono text-dim" style={{ fontSize: 11 }}>{r.subject}</div>
                                </td>
                                <td className="mono" title={r.hwid ?? ""}>{shortHwid(r.hwid)}</td>
                                <td><span className={`pill ${r.active ? "active" : "lifted"}`}>{r.active ? "active" : "lifted"}</span></td>
                                <td>{r.category ?? "—"}</td>
                                <td className="text-dim" style={{ maxWidth: 400, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={r.reason}>{r.reason}</td>
                                <td className="text-dim">{r.source}</td>
                                <td>
                                    {r.active && <button className="danger" onClick={() => liftBan(r.id)}>Lift</button>}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <Pager total={data.total} limit={LIMIT} offset={offset} onChange={setOffset} />
            </div>
        </>
    );
}
